import {
  type HTTPStatusCategory,
  contentTypeCategoryToLabel,
  convertHeadersToArray,
  getContentType,
  getContentTypeCategory,
  getStatusCategory,
} from '@carboncopyco/editor-utils';
import type { HTTPRequest, HTTPResponse } from '@carboncopyco/types';
import { Badge, type BadgeProps } from '@carboncopyco/ui';

const statusCategoryToVariant: Record<
  HTTPStatusCategory,
  BadgeProps['variant']
> = {
  informational: 'blue',
  successful: 'green',
  redirection: 'yellow',
  clientError: 'red',
  serverError: 'red',
};

const TransactionBadge = ({
  label,
  variant,
}: Pick<BadgeProps, 'label' | 'variant'>) => (
  <Badge
    label={label}
    variant={variant}
    round
    size="md"
  />
);

export const MethodBadge = ({ method }: { method: HTTPRequest['method'] }) => (
  <TransactionBadge
    label={method}
    variant="yellow"
  />
);

export const StatusBadge = ({ status }: { status: HTTPResponse['status'] }) => {
  const statusCategory = getStatusCategory(status);

  return (
    <TransactionBadge
      label={String(status)}
      variant={statusCategoryToVariant[statusCategory] ?? 'grey'}
    />
  );
};

export const ContentTypeBadge = ({
  headers,
}: {
  headers: HTTPResponse['headers'];
}) => {
  const contentTypeCategory = getContentTypeCategory(
    getContentType(convertHeadersToArray(headers))
  );
  return (
    <TransactionBadge
      label={contentTypeCategoryToLabel[contentTypeCategory]}
      variant="grey"
    />
  );
};

export const ModifiedBadge = () => (
  <TransactionBadge
    label="Modified"
    variant="blue"
  />
);
